/** ファイルサイズの上限（100MB） */
export const MAX_FILE_SIZE = 100 * 1024 * 1024

/** ファイルサイズ上限の表示用文字列（validation のエラーメッセージ用） */
export const formatFileSizeLimit = (bytes) => {
  const mb = bytes / (1024 * 1024)
  return `${mb}MB`
}

/** 集計種別の表示ラベル */
export const PERIOD_KIND_LABELS = {
  monthly: '月次',
  quarter: '四半期',
  quarterly: '四半期',
  yearly: '年次'
}

/** データ種別の値（IF02080 / IF02104 data_category） */
export const DATA_CATEGORY = Object.freeze({
  EMPLOYEE: 'employee',
  COMPANY: 'company'
})

/** データ種別の表示ラベル（'' は未選択） */
export const DATA_CATEGORY_LABELS = Object.freeze({
  [DATA_CATEGORY.EMPLOYEE]: '従業員別',
  [DATA_CATEGORY.COMPANY]: '会社別'
})

/** データ種別セレクトボックスの選択肢（「未選択」は ChrofyCustomSelect の hasNoSelect で付与） */
export const DATA_CATEGORY_OPTIONS = Object.freeze([
  { value: DATA_CATEGORY.EMPLOYEE, label: DATA_CATEGORY_LABELS[DATA_CATEGORY.EMPLOYEE] },
  { value: DATA_CATEGORY.COMPANY, label: DATA_CATEGORY_LABELS[DATA_CATEGORY.COMPANY] }
])

/** タスク期間種別: 月次（ベースファイルトグルの表示判定に使用） */
export const PERIOD_KIND_MONTHLY = 'monthly'

/** ファイル種別名の最大文字数 */
export const FILE_TYPE_NAME_MAX_LENGTH = 255

/** ファイル種別名に使用不可な文字の正規表現 */
export const FILE_TYPE_NAME_INVALID_CHARS_REGEX = /[/\\?*:;"<>|]/

/** モーダル内テーブルセル幅（FileContentModal 用） */
export const TABLE_CELL_WIDTH = 200

/** モーダル内テーブル幅のバッファ（FileContentModal 用） */
export const TABLE_WIDTH_BUFFER = 100

/** チャンクサイズの閾値（50MB） */
export const CHUNK_SIZE_THRESHOLD = 50 * 1024 * 1024

/** チャンクサイズ（1MB/チャンク） */
export const CHUNK_SIZE_BYTES = 1 * 1024 * 1024

/** 行数ベースチャンクサイズ（50MB超のファイル: 50行/チャンク） */
export const CHUNK_SIZE_SMALL = 50

/** 行数ベースチャンクサイズ（50MB以下のファイル: 100行/チャンク） */
export const CHUNK_SIZE_LARGE = 100

/** 許可される拡張子 */
export const ALLOWED_EXTENSIONS = ['csv', 'xlsx', 'xls']
